import { ENV_NAME, LS_CONFIGS_KEY, ChainProvider, ThetanChainId } from './types';
export const defaultConfig = {
  general: {
    env: process.env.NODE_ENV || ENV_NAME.PRODUCTION,
    isInternal: Boolean(process.env.INTERNAL),
    appVersion: process.env.APP_VERSION ?? 'unknown',
    sentryAuthToken: process.env.SENTRY_AUTH_TOKEN ?? ''
  },
  endpoints: {
    thetanAuth: '',
    thetanReport: '',
    thetanSupport: '',
    thetanMarket: '',
    thetanLeaderboard: '',
    thetanResourceWEBGL: '',
    thetanResource: ''
  },
  chain: getDefaultChainConfig()
};

function getDefaultChainConfig() {
  if (process.env.NODE_ENV !== ENV_NAME.PRODUCTION) {
    return {
      chainProvider: ChainProvider.BSC_TEST,
      thetanChainId: ThetanChainId.TEST
    };
  }

  return {
    chainProvider: ChainProvider.BSC_MAIN,
    thetanChainId: ThetanChainId.MAIN
  };
}

const parseConfig = configStr => {
  try {
    var _defaultConfig$genera, _defaultConfig$genera2, _defaultConfig$genera3;

    const configObj = JSON.parse(configStr);
    const {
      general,
      endpoints,
      chain
    } = configObj;
    const {
      isInternal,
      appVersion,
      env,
      sentryAuthToken
    } = general ?? {};
    const {
      thetanAuth,
      thetanReport,
      thetanLeaderboard,
      thetanMarket,
      thetanResource,
      thetanSupport,
      thetanResourceWEBGL
    } = endpoints ?? {};
    const {
      thetanChainId,
      chainProvider
    } = chain ?? {};
    return {
      general: {
        env: Object.values(ENV_NAME).includes(env) ? env : ENV_NAME.PRODUCTION,
        isInternal: typeof isInternal === 'boolean' ? isInternal : (_defaultConfig$genera = defaultConfig.general) === null || _defaultConfig$genera === void 0 ? void 0 : _defaultConfig$genera.isInternal,
        appVersion: typeof appVersion === 'string' ? appVersion : (_defaultConfig$genera2 = defaultConfig.general) === null || _defaultConfig$genera2 === void 0 ? void 0 : _defaultConfig$genera2.appVersion,
        sentryAuthToken: typeof sentryAuthToken === 'string' ? sentryAuthToken : (_defaultConfig$genera3 = defaultConfig.general) === null || _defaultConfig$genera3 === void 0 ? void 0 : _defaultConfig$genera3.sentryAuthToken
      },
      endpoints: {
        thetanAuth: typeof thetanAuth === 'string' ? thetanAuth : '',
        thetanReport: typeof thetanReport === 'string' ? thetanReport : '',
        thetanSupport: typeof thetanSupport === 'string' ? thetanSupport : '',
        thetanLeaderboard: typeof thetanLeaderboard === 'string' ? thetanLeaderboard : '',
        thetanMarket: typeof thetanMarket === 'string' ? thetanMarket : '',
        thetanResource: typeof thetanResource === 'string' ? thetanResource : '',
        thetanResourceWEBGL: typeof thetanResourceWEBGL === 'string' ? thetanResourceWEBGL : ''
      },
      chain: {
        chainProvider: Object.values(ChainProvider).includes(chainProvider) ? chainProvider : getDefaultChainConfig().chainProvider,
        thetanChainId: Object.values(ThetanChainId).includes(thetanChainId) ? thetanChainId : getDefaultChainConfig().thetanChainId
      }
    };
  } catch (_) {
    return defaultConfig;
  }
};

export const getAppConfig = () => {
  const configStr = window.localStorage.getItem(LS_CONFIGS_KEY);
  if (configStr === null) return defaultConfig;
  return parseConfig(configStr);
};
export const setAppConfig = configs => {
  window.localStorage.setItem(LS_CONFIGS_KEY, JSON.stringify(configs));
};
export const removeAppConfig = () => {
  window.localStorage.removeItem(LS_CONFIGS_KEY);
};